export default "__VITE_ASSET__v4c7hV7n__"